<div [disableTooltip]="areThereRowsSelected | async"
     ngbTooltip="Select some rows to start to explore and download"
     placement="bottom">
  <button id="download"
          type="button"
          class="btn btn-success text-white ms-1 d-flex align-items-center justify-content-center"
          style="height: 30px; width: 120px;"
          (click)="download()"
          [disabled]="!(areThereRowsSelected | async)">
    <i class="fa-light fa-download me-2"></i>Download
  </button>
</div>
